/**
 * Marker of DOM UI placed inside the canvas (text editor and its bar, title and label editors, menus, controls): the
 * controller leaves its pointer, double-click, context-menu and key events alone, so it never steals their focus.
 */
export const CANVAS_UI = 'data-canvas-ignore';

export const isCanvasUi = (t: EventTarget | null): boolean => t instanceof Element && !!t.closest(`[${CANVAS_UI}]`);

/** The surface of every bar over the canvas (P15): opaque chrome with the float shadow, never a blur (60 fps). */
export const FLOATING_BAR = 'bg-chrome shadow-float';
